import { conveyanceService } from "../../../../Api/Services/ConveyanceService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import { IBaseResponse } from "../../../../Types/UserProfileDetails";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";

/**
 * Async thunk to handle apply conveyance.
 * Dispatches an API call to the conveyance apply service.
 */
export const employeeConveyanceAdd = createServiceAsyncThunk<
  IBaseResponse, // Response Type
  FormData // Payload Type
>(
  ACTION_NAMES.EMPLOYEE_CONVEYANCE_ADD, // Action name
  (applyConveyanceFormData) =>
    conveyanceService.applyConveyance(applyConveyanceFormData), // API Call
  ERROR_MESSAGES.EMPLOYEE_CONVEYANCE_ADD_FAILURE // Error Message
);

/**
 * Slice to manage the state of apply conveyance.
 * Includes actions to clear errors and handle async states.
 */
const employeeConveyanceAddSlice = createGenericSlice<IBaseResponse, FormData>(
  SLICE_NAMES.EMPLOYEE_CONVEYANCE_ADD, //Slice Name
  employeeConveyanceAdd // Async Thunk
);

// Export actions to be used in components for resetting error and details
export const {
  clearError: clearEmployeeConveyanceAddError,
  clearSuccessMessage: clearEmployeeConveyanceAddSuccess,
} = employeeConveyanceAddSlice.actions;

// Export the reducer to be included in the Redux store
export default employeeConveyanceAddSlice.reducer;
